import { createTheme } from "@material-ui/core";

export const primaryColor = "#000000";
export const secondaryColor = "#664eae";

export const theme = createTheme({
  palette: {
    type: "light",
    primary: {
      main: primaryColor,
    },
    secondary: {
      main: secondaryColor,
    },
    text: {
      primary: "rgba(0, 0, 0, 0.81)",
      secondary: "rgba(0, 0, 0, 0.49)",
      disabled: "rgba(0, 0, 0, 0.35)",
      hint: "rgba(0, 0, 0, 0.34)",
    },
    background: {
      paper: "#fff",
      default: "#efefef",
    },
  },
  typography: {
    fontFamily: [
      "-apple-system",
      "BlinkMacSystemFont",
      '"Segoe UI"',
      "Roboto",
      '"Helvetica Neue"',
      "Arial",
      "sans-serif",
      '"Apple Color Emoji"',
      '"Segoe UI Emoji"',
      '"Segoe UI Symbol"',
    ].join(","),
  },
  shape: {
    borderRadius: 6,
  },
});
